import type { AxiosResponse } from "axios";
import type { DriverGuideUrl } from "@/models/driverGuides";
import { httpClient } from "./API";

export const getDriverGuideUrlAPI = async (
  id: number,
): Promise<AxiosResponse<DriverGuideUrl>> => {
  return httpClient.get(`core/internal/calgary/driverGuides/${id}`);
};
